import { notificationService } from '../../../shared';
import * as actionTypes from './actionTypes';

const fetchNotificationsStart = () => ({
    type: actionTypes.FETCH_NOTIFICATIONS_START,
});

const fetchNotificationsSuccess = (data) => ({
    type: actionTypes.FETCH_NOTIFICATIONS_SUCCESS,
    data,
});

const fetchNotificationsFail = (error) => ({
    type: actionTypes.FETCH_NOTIFICATIONS_FAIL,
    error,
});

export const fetchNotifications = (page) => {
    return (dispatch) => {
        dispatch(fetchNotificationsStart());
        notificationService
            .getNotifications(page)
            .then((response) => dispatch(fetchNotificationsSuccess(response)))
            .catch((error) => dispatch(fetchNotificationsFail(error)));
    };
};

const fetchNotificationsUnreadStart = () => ({
    type: actionTypes.FETCH_NOTIFICATIONS_UNREAD_START,
});

const fetchNotificationsUnreadSuccess = (data) => {
    return {
        type: actionTypes.FETCH_NOTIFICATIONS_UNREAD_SUCCESS,
        payload: {
            notificationsUnread: data,
        },
    };
};

const fetchNotificationsUnreadFail = (error) => ({
    type: actionTypes.FETCH_NOTIFICATIONS_UNREAD_FAIL,
    payload: { error },
});

export const fetchNotificationsUnread = (subprojectId) => (dispatch) => {
    dispatch(fetchNotificationsUnreadStart());
    notificationService
        .getNotificationUnread(subprojectId)
        .then((response) =>
            dispatch(
                fetchNotificationsUnreadSuccess({
                    count: response.count,
                    results: response.results,
                    updateStatus: response.update_status,
                })
            )
        )
        .catch((error) => dispatch(fetchNotificationsUnreadFail(error)));
};
